export default __webpack_public_path__ + "static/media/OrlandoSentinel.c0dabae2.png";